<!--
 * @Author: your name
 * @Date: 2021-10-26 15:31:11
 * @LastEditTime: 2022-03-23 15:43:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\peopleInfo\components\dialog-map.vue
-->
<template>
  <div class="track-dialog">
    <el-dialog :title="drawType==2?'人员轨迹详情':'车辆轨迹详情'"
               width="75%"
               :before-close="onCloseMap"
               @close="onCloseMap"
               :fullscreen="fullScreen"
               :visible.sync="showMap">
      <div class="track-dialog__wrapper">
        <div id="mini-map"></div>
        <div class="track-dialog__main">
          <div class="header-title"> {{drawType==2?'人员信息':'车辆信息'}}</div>
          <!-- 基本信息 -->
          <div>
            <div class="header-content"
                 v-if="drawType==2">
              <img :src="imgPath(dialogInfo.facePicFileCode || dialogInfo.fileCode)"
                   class="image"
                   onerror="this.src='/images/theme/newDark/default.png'" />
              <div class="detail">
                <div>
                  <span class="detail--gray">姓名：</span>
                  <span>{{dialogInfo.name}}</span>
                </div>
                <div>
                  <span class="detail--gray">岗位： </span>
                  <span>{{dialogInfo.position}}</span>
                </div>
                <div>
                  <span class="detail--gray">手机号： </span>
                  <span>{{dialogInfo.phone}}</span>
                </div>
              </div>
            </div>
            <div class="header-content"
                 v-else>
              <img :src="imgPath(dialogInfo.fileCode)"
                   class="image"
                   onerror="this.src='/images/theme/newDark/default.png'" />
              <div class="detail">
                <div>
                  <span class="detail--gray">车主： </span>
                  <span>{{ dialogInfo.name || dialogInfo.ownerName || drawInfo.ownerName}}</span>
                </div>
                <div>
                  <span class="detail--gray">车牌： </span>
                  <span>{{ drawInfo.plateCode }}</span>
                </div>
                <div>
                  <span class="detail--gray">类型： </span>
                  <span>{{ drawInfo.personnelType==2?'访客':drawInfo.personnelType==1?'员工':"" }}</span>
                </div>
                <div>
                  <span class="detail--gray">颜色： </span>
                  <!-- <span v-if="dialogInfo.vehicleColor!=null">{{ dialogInfo.vehicleColor.toString() | dic('SENU039')}}</span> -->
                  <span >{{ drawInfo.vehicleColorName}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="title">轨迹信息</div>
          <!-- 轨迹数组信息 -->
          <el-scrollbar class="track">
            <div v-for="(item, index) in drawList"
                 :key="'time'+index"
                 @click.stop="onGetTrajectory(item, index)"
                 :class="['trajectoryId' + index, 'track__list',showDrawIndex==index ? 'track--checked' : '']">
              <!-- 时间轴 -->
              <div class="track__list__time">
                <div>
                  <span>时间：</span>
                  <span>{{item.recordDate || item.date}}</span>
                </div>
                <span :class="showDrawIndex==index ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></span>
              </div>
              <!-- 详细时间轨迹信息 -->
              <div v-for="(val, indexIner) in (drawType==2? item.points[0] : item.trailList)"
                   :key="indexIner"
                   :class="'track__list__detail ' + (showDrawIndex==index ? 'expand' : 'collspand')">
                <div style="width:100%"
                     v-if="indexIner < showDrawNum">
                  <div class="detail-img">
                    <img :src="drawType==2?val.face_img_url :imgPath(val.rimageUrl)"
                         @click.stop="onHandlePositon(val)"
                         class="detail-img__img"
                         onerror="this.src='/images/theme/newDark/default.png'" />
                    <input type="checkbox"
                           class="detail-img--check"
                           :name="(drawType==2?item.recordDate:item.date) + indexIner"
                           @click.stop="onHandleCheckedChange($event, val, drawType==2?item.recordDate:item.date, indexIner)" />
                  </div>
                  <div>
                    <span>时间：</span>
                    <span>{{ drawType==2?val.recordTime4Sort.trim().split(' ')[1]:val.time }}</span>
                  </div>
                  <div v-if="drawType==2">
                    <span>相似度：</span>
                    <span>{{ val.similarity }}%</span>
                  </div>
                </div>
              </div>
              <div v-if="(drawType==2? item.points[0] : item.trailList).length>showDrawNum"
                   @click.stop="onGetMoreList"
                   :class="'track__list__btn ' + (showDrawIndex==index? 'track__list--expand' : 'track__list--collspand')">
                <el-button size="mini"
                           type="primary">查看更多</el-button>
              </div>
            </div>
          </el-scrollbar>

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Bus, Dates, } from '$utils'
export default {
  name: "map-track-dialog",
  data () {
    return {
      showDrawNum: 6,//默认展示轨迹初始数量，和【加载更多】btn搭配使用
      dialogInfo: {},//弹窗信息：人员，车辆的基本信息对象
      drawInfo: {},
      showDrawIndex: 0,//当前展开的轨迹下标位置
      fullScreen: false,//是否未全屏dialog
      showMap: false,//弹窗是否打开
      drawType: "",//轨迹类型：1车辆，2人员
      drawList: [],//轨迹信息数组
      drawPeopleApi: '/vas/personnelControl/personnelSearching/peopleTrackDetails.json',//人员轨迹api
      drawCarApi: '/vas/vehicleSearching/searchVehicleTrail.json',//车辆轨迹api
      checkDrawList: [],//选中的轨迹图片信息数组
      checkDrawIdList: [],//选中的轨迹标识数组
      // 人员轨迹查询入参对象
      paramPeople: {
        pageNo: 1,
        pageSize: 100,
        startTime: Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000 * 7),
        endTime: Dates.format(new Date()),
        threshold: 93,//精确度
      },
      // 车辆轨迹查询入参对象
      paramCar: {
        startTime: Dates.parse(Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000 * 7)),
        endTime: Dates.parse(Dates.format(new Date())),
        plateCode: '',//车牌号
      },

    }
  },
  mounted () {
    // 默认隐藏地图
    this.$map.hideMap2D()
  },
  methods: {
    // 加载更多
    onGetMoreList () {
      this.showDrawNum += 6
    },
    // 图片下载
    imgPath (fileId) {
      return fileId ? Bus.imgPath(fileId) : ''
    },
    // 弹出关闭/取消，同时销毁地图，移除已绘制的轨迹：
    onCloseMap () {
      this.showMap = false
      this.$map.hideMap2D()//关闭地图
      this.$map.MapInstance2D.closeTips()//关闭气泡
      this.$map.MapInstance2D.removeTrajectory()//清除轨迹
    },
    // 初始化地图，将全局地图组件挂载在#mini-map元素上并居中：resetMapStyle(将地图挂载在某个元素上)
    initMap () {
      this.$map.MapInstance2D.positionByPoint()
      this.$map.MapInstance2D.resetMapStyle('mini-map')
    },
    // 时间日期格式转换
    filterTime (time) {
      let date = time.substring(0, 19)
      date = date.replace(/-/g, '/')
      return new Date(date).getTime()
    },
    // 点击时间日期将暂时当前时间日期下的所有轨迹并销毁之前的一切操作：showDrawTrajectory绘制方法
    onGetTrajectory (item, index) {
      this.showDrawNum = 6
      this.checkDrawList = []
      this.checkDrawIdList = []
      // 初始化img-input 选中状态
      let divs = document.querySelectorAll('.detail-img--check');
      [].forEach.call(divs, function (div) {
        div.checked = false;
      });
      this.$nextTick(() => {
        if (this.showDrawIndex == index) {
          this.showDrawIndex = "-1"
        } else {
          this.showDrawIndex = index
          this.showDrawTrajectory(this.drawType == 2 ? item.points[0] : item.trailList)
        }
      })

    },
    // 选中/取消勾选图片，同时将已勾选所有图片轨迹信息绘制在地图上：showDrawTrajectory绘制方法
    onHandleCheckedChange (event, val, date, index) {
      let checkboxFlag = document.getElementsByName(date + index)
      if (checkboxFlag[0].checked) {
        // 选中状态
        this.checkDrawList.push(val)
        this.checkDrawIdList.push(this.drawType == 2 ? val.recordTime : val.fullTime)
      } else {
        // 取消选中
        let spliceIndex = this.checkDrawIdList.indexOf(this.drawType == 2 ? val.recordTime : val.fullTime)
        this.checkDrawList.splice(spliceIndex, 1)
        this.checkDrawIdList.splice(spliceIndex, 1)
      }
      this.showDrawTrajectory(this.checkDrawList)
    },
    // 点击图片将图片轨迹居中定位在地图上：positionByPoint居中方法
    onHandlePositon (val) {
      this.$map.MapInstance2D.positionByPoint([val.lng || val.longitude, val.lat || val.latitude])
    },
    // 绘制轨迹信息：drawTrajectory地图绘制OD线方法
    showDrawTrajectory (item) {
      let drawItem = JSON.parse(JSON.stringify(item))
      // 移除可能出现的轨迹和气泡
      this.$map.MapInstance2D.removeTrajectory()
      this.$map.MapInstance2D.closeTips()
      let setPoint = []
      let src = ''
      let dataInfo = {};
      // 根据时间排序showTime，recordTime
      if (this.drawType == 1) {
        drawItem.sort((a, b) => {
          a.showTime = this.filterTime(a.fullTime)
          var x = 'showTime'
          var value1 = a[x];
          var value2 = b[x];
          return value1 - value2;
        })
        //合并相同项，相同经纬度轨迹合并展示
        drawItem.forEach((data, index) => {
          data.trajectoryType = 'vehicle'
          let { longitude } = data;
          let { latitude } = data;
          if (!dataInfo[longitude] && !dataInfo[latitude]) {
            dataInfo[longitude] = {
              data,
              child: []
            }
          }
          dataInfo[longitude].child.push(data);
        });
      } else {
        drawItem.sort((a, b) => {
          var x = 'recordTime'
          var value1 = a[x];
          var value2 = b[x];
          return value1 - value2;
        })
        drawItem.forEach((data, index) => {
          let { lng } = data;
          let { lat } = data;
          if (!dataInfo[lng] && !dataInfo[lat]) {
            dataInfo[lng] = {
              data,
              child: []
            }
          }
          dataInfo[lng].child.push(data);
        });
      }
      let list = Object.values(dataInfo);
      list.map((val, index) => {
        if (index === 0) {
          src = './images/theme/newDark/map/state.png'
        } else if (index === (list.length - 1)) {
          src = './images/theme/newDark/map/end_point.png'
        } else {
          src = this.drawType == 1 ? './images/theme/newDark/map/car.png' : './images/theme/newDark/map/finish_click.png'
        }
        // 封装数据，用于绘制轨迹
        setPoint.push({
          point: (() => {
            let ary = []
            ary.push(val.data.longitude || val.data.lng)
            ary.push(val.data.latitude || val.data.lat)
            ary.push(src)
            ary.push(val.child.length > 1 ? val.child : val.child[0])
            return ary
          })(val),
        })
      })
      //绘制轨迹信息并地图居中显示
      setPoint.length ?
        this.$map.MapInstance2D.positionByPoint(setPoint[setPoint.length - 1].point) :
        this.$map.MapInstance2D.setMapOption()
      this.$map.MapInstance2D.drawTrajectory(setPoint, 1)
    },
    // 打开弹窗，初始化数据和操作
    openMap (row, type = 2, param) {
      this.showDrawNum = 6
      this.drawType = type
      this.dialogInfo = row
      this.showDrawIndex = "0"
      this.checkDrawList = []
      this.checkDrawIdList = []
      let divs = document.querySelectorAll('.detail-img--check');
      [].forEach.call(divs, function (div) {
        div.checked = false;
      });
      if (type == 1) {
        this.getDrawListCar(row, param)
      } else {
        this.getDrawList(row)
      }

    },
    // 查询车辆轨迹
    getDrawListCar (row, params) {
      let param = {}
      if (params) {
        param = Object.assign({}, params)
      } else {
        param = Object.assign({}, this.paramCar)
        param.plateCode = row.plateCode
      }
      const loading = this.$loading({
        lock: true,
        text: '轨迹请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(this.drawCarApi, param).then((res) => {
        loading.close()
        if (res.success) {
          if (!res.returnObj || !res.returnObj.length) {
            this.$message.warning('暂无轨迹信息')
            return
          }
          this.showMap = true
          this.drawList = res.returnObj[0].dateList
          this.drawInfo = res.returnObj[0]//轨迹信息
          this.$nextTick(() => {
            this.$map.showMap2D(this.initMap)
            this.showDrawTrajectory(this.drawList[0].trailList)
          })
        } else {
          this.$message.error(res.msgContent)
        }
      });
    },
    // 查询人员轨迹
    getDrawList (row, isnext = false) {
      let param = Object.assign({}, this.paramPeople)
      if (isnext) {
        param.fileId = row.facePicFileCode
      } else {
        param.personnelCode = row.personnelCode//人员信息
        param.faceCode = row.code//人脸注册
      }
      const loading = this.$loading({
        lock: true,
        text: '轨迹请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(this.drawPeopleApi, param).then((res) => {
        if (res.success) {
          if (!res.returnObj || !res.returnObj.length) {
            if (!row.facePicFileCode || isnext) {
              loading.close()
              this.$message.warning('暂无轨迹信息')
            } else {
              this.getDrawList(row, true)
            }
            return
          }
          this.drawList = res.returnObj
          loading.close()
          this.showMap = true
          this.$nextTick(() => {
            this.$map.showMap2D(this.initMap)
            this.showDrawTrajectory(res.returnObj[0].points[0])
          })
        } else {
          loading.close()
          this.$message.error(res.msgContent)
        }
      });
    },

  },
}
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.track-dialog {
  .title {
    font-size: 15px;
    @include set_theme_color(color, main-theme-color);
  }
  .bg-color {
    @include set_theme_color(background-color, item-active-bg-color);
  }
  &__wrapper {
    display: flex;
    height: 600px;
    display: flex;
    #mini-map {
      height: 580px;
      width: 70%;
    }
  }
  &__main {
    width: 30%;
    padding-left: 10px;
    .header-title {
      @extend .title;
    }
    .header-content {
      display: flex;
      padding: 5px;
      margin: 10px 0;
      @extend .bg-color;
      .image {
        width: 110px;
        height: 110px;
      }
      .detail {
        div {
          margin: 10px;
        }
        &--gray {
          color: #95a6c1;
          width: 57px;
          display: inline-block;
        }
      }
    }
    .track {
      height: 400px;
      &__list {
        display: flex;
        flex-flow: row wrap;
        padding: 10px;
        border-radius: 5px;
        margin: 10px 0px;
        position: relative;
        cursor: pointer;
        @extend .bg-color;
        font-size: 12px;
        &__time {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }
        &__detail {
          display: flex;
          margin: 5px 1%;
          width: 31%;
          &.expand {
            height: 100%;
          }
          &.collspand {
            display: none;
          }
          .detail-img {
            position: relative;
            height: 0; // 设置高为0，让padding撑起高
            padding-bottom: 90%;
            margin-bottom: 10px;
            &__img {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
            }
            &--check {
              position: absolute;
              top: 5px;
              right: 5px;
            }
          }
        }
        &__btn {
          width: 100%;
          text-align: center;
        }
        &--expand {
          height: 100%;
          margin-bottom: 10px;
        }
        &--collspand {
          display: none;
        }
        &:hover {
          opacity: 0.8;
        }
      }
      &--checked {
        @include set_theme_color(border-color, main-theme-color);
        border: 1px solid;
      }
    }
  }
}
</style>
